import React, { Component } from "react";
import PropTypes from "prop-types";
import { BrowserRouter, Switch, Route } from "react-router-dom";

import { CLIENT_DELOITTE, CLIENT_DEFAULT } from "./constants";

import PrivateRoute from "./container/PrivateRoute";
import RedirectWithSearch from "./container/RedirectWithSearch";
import TopBar from "./container/RequestPortalTopBar";

// Pages
import LoginPage from "./page/Login";
import LoginDeloitte from "./page/Login.Deloitte";
import LoginDefault from "./page/Login.Default";
import LayoutComponent from "./App/Layout";
import { Logout, CrossTabLogoutHandler } from "./page/Logout";
import TestErrorPage from "./page/TestError";

import { withProps } from "./util";
// Request portal
import RequestPortalCreatePage from "./page/RequestPortal/Create";
import RequestPortalEditPage from "./page/RequestPortal/Edit";
import TicketsPage from "./page/RequestPortal/Tickets";
import RequestPortalViewPage from "./page/RequestPortal/View";
import LegalDisclaimer from "./page/RequestPortal/legal/LegalDisclaimer";
import ContinuousMonitoring from "./page/RequestPortal/ContinuousMonitoring";
import BulkRequestPage from "./page/RequestPortal/BulkRequest";

const menuItems = [
    {
        link: "/tickets/",
        label: "My Requests",
    },
];

const getLoginPageConfig = client => {
    switch (client) {
        case CLIENT_DELOITTE:
            return {
                layout: LoginDeloitte,
                token: true,
                error: "Invalid username, password or token. Please try again.",
            };
        default:
            return {
                layout: LoginDefault,
                token: false,
                error: "Invalid username or password. Please try again.",
            };
    }
};

class App extends Component {
    state = {
        layoutType: "blank",
    };

    changeLayoutType = type => {
        if (this.state.layoutType !== type) {
            this.setState({ layoutType: type });
        }
    };

    render() {
        const { client } = this.props;
        const PrivateRouteFn = withProps(PrivateRoute, {
            changeLayoutType: this.changeLayoutType,
            oldLayoutType: this.state.layoutType,
        });

        return (
            <BrowserRouter basename="/request-portal/">
                <>
                    <Switch>
                        <Route path="/logout" render={() => null} />
                        {/* render logout handler everywhere except /logout, this is easier than long regex */}
                        <Route path="/" component={CrossTabLogoutHandler} />
                    </Switch>
                    <LayoutComponent
                        layoutType={this.state.layoutType}
                        menuItems={menuItems}
                        TopBarComponent={TopBar}
                    >
                        <Switch>
                            <PrivateRouteFn
                                exact
                                layoutType="menu"
                                path="/logout/"
                                component={Logout}
                            />
                            <Route
                                path="/login/"
                                component={props => {
                                    this.changeLayoutType("login");
                                    return (
                                        <LoginPage
                                            isRequestPortal
                                            config={getLoginPageConfig(client)}
                                            {...props}
                                        />
                                    );
                                }}
                            />
                            <Route
                                path="/_test_error/"
                                component={TestErrorPage}
                            />
                            <Route
                                path="/legal-disclaimer/"
                                component={LegalDisclaimer}
                            />
                            <PrivateRouteFn
                                exact
                                layoutType="bar"
                                path={[
                                    "/tickets/",
                                    "/tickets/requests/",
                                    "/tickets/bulk/",
                                ]}
                                component={TicketsPage}
                                styleless
                            />
                            <PrivateRouteFn
                                exact
                                layoutType="bar"
                                path="/bulkrequest/:id/"
                                component={BulkRequestPage}
                                styleless
                            />
                            <PrivateRouteFn
                                exact
                                layoutType="bar"
                                path="/tickets/create/"
                                component={RequestPortalCreatePage}
                                styleless
                            />
                            <PrivateRouteFn
                                exact
                                layoutType="bar"
                                path="/tickets/:ulid/edit/"
                                component={withProps(RequestPortalEditPage, {
                                    action: "edit",
                                    title: "Edit request",
                                })}
                                styleless
                            />
                            <PrivateRouteFn
                                exact
                                layoutType="bar"
                                path="/tickets/:ulid/renew/"
                                component={withProps(RequestPortalEditPage, {
                                    action: "renew",
                                    title: "Renew request",
                                })}
                                styleless
                            />
                            <PrivateRouteFn
                                exact
                                layoutType="bar"
                                path="/tickets/:ulid/"
                                component={RequestPortalViewPage}
                                styleless
                            />
                            <PrivateRouteFn
                                layoutType="bar"
                                path="/tickets/:ulid/continuous_monitoring"
                                component={ContinuousMonitoring}
                            />
                            <RedirectWithSearch from="/" to="/tickets/" />
                        </Switch>
                    </LayoutComponent>
                </>
            </BrowserRouter>
        );
    }
}

App.propTypes = {
    client: PropTypes.oneOf([CLIENT_DELOITTE, CLIENT_DEFAULT]),
};

export default App;
